import MoveGroupMembersModal from './MoveGroupMembersModal';

export default MoveGroupMembersModal;
